module.exports = __webpack_public_path__ + "resource/img/u326.7f8bb990.svg";